import { useMutation, useQuery } from '@tanstack/react-query';
import { AutoRefreshSettingsDto } from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';

export const useAutoRefresh = () => {
  const query = useQuery<AutoRefreshSettingsDto>({
    queryKey: [QueryKey.knowledgeBase.autoRefresh],
  });

  const mutation = useMutation<AutoRefreshSettingsDto, unknown, boolean>({
    mutationKey: [QueryKey.knowledgeBase.autoRefreshUpdate],
  });

  return {
    settings: query.data,
    isLoading: query.isLoading,
    setEnabled: (enabled: boolean) => mutation.mutate(enabled),
    isPending: mutation.isPending,
  };
};
